import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, Wrestler, WrestlerInMatch } from '../../../types';
import { BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';

const ContainerBlockAllWrestlers = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 35%;
    padding: 0 30px;
    gap: 5px;
`;

const BoxWrestler = styled.div<{ $isWinner: boolean }>`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    width: 50px;
    height: 50px;
    border: ${({ $isWinner }) => $isWinner ? '2px solid gold' : '2px solid rgba(163, 27, 27, 0.45)'};
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: ${({ $isWinner }) => $isWinner ? 'gold' : 'rgba(163, 27, 27, 0.85)'};
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

const ContainerWinnerRumble = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 35%;
    height: 100%;
    padding-top: 40px;
`;

interface SpaceForWinnerRumbleProps {
    numberOfWinners: number;
}

const SpaceForWinnerRumble = styled.div<SpaceForWinnerRumbleProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: ${props => `calc(100% / ${props.numberOfWinners} - 5px)`};
    height: 100%;

    & .box-winner-generic-rumble {
        position: relative;
        width: 100%;
        max-width: 200px;
        height: 200px;
        overflow: hidden;
        border: 2px solid rgba(163, 27, 27, 0.45);
        cursor: pointer;
        transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

        &:hover {
            transform: scale(1.04);
            border-color: rgba(163, 27, 27, 0.85);
            box-shadow: 0 0 12px rgba(163, 27, 27, 0.25);
        }
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        display: block;
    }

    & .name-wrestler {
        font-size: 14px;
        font-weight: 600;
        margin-top: 6px;
        text-transform: uppercase;
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

interface RumbleMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch | Wrestler) => void;
}

const RumbleMatchCard: FC<RumbleMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    // prendo props.match.wrestlers e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const wrestlers = matchInfo.wrestlers;
    const winners = matchInfo.winners;

    // renderizza un singolo wrestler
    const renderSingleWrestler = (wrestler: WrestlerInMatch, key: number, side: 'left' | 'right') => {
        const isWinner = !!(wrestler.pivot && wrestler.pivot.is_winner);
        return (
            <BoxWrestler
             $isWinner={isWinner}
             className={`box-wrestler ${side}`}
             onClick={() => navigateToWrestler(wrestler)}
             key={key}
            >
                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} title={wrestler.name} />
            </BoxWrestler>
        );
    };

    // renderizza vincitore
    const renderWinnerRumble = (winner: Wrestler, key: number, numberOfWinners: number) => {
        return (
            <SpaceForWinnerRumble className="box-wrestler-winner-rumble" key={key} numberOfWinners={numberOfWinners}>
                <div className="box-winner-generic-rumble">
                    <img src={process.env.REACT_APP_STORAGE_URL + winner.avatar_path} alt={winner.name} />
                    <BoxWinnerGeneric>
                        <span className="winner-text">WIN</span>
                        {matchInfo.win_by_dq ?
                            <span className="by-dq">BY DQ</span>
                        : null}
                    </BoxWinnerGeneric>
                </div>
                <h6 className="name-wrestler">{winner.name}</h6>
            </SpaceForWinnerRumble>
        );
    };

    // JSX
    return (
        <DefaultContainerCard
         key={keyMatchInfo}
         style={{
            paddingLeft: '30px',
            paddingRight: '30px'
        }}
         className="rumble-match-card">
            <TopDecorColor />

           <ContainerBlockAllWrestlers className="container-block-all-wrestlers-left">
                {wrestlers.map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'left')
                ))}
            </ContainerBlockAllWrestlers>

            <CenterInfoFightComponentRender
                className="center-info-fight-component-render-rumble"
                nameMatch="Battle Royal"
                matchInfo={matchInfo}
            />

            <ContainerWinnerRumble className="container-block-all-wrestlers-right">
                {winners.map((winner, key) => (
                    renderWinnerRumble(winner, key, winners.length)
                ))}
            </ContainerWinnerRumble>
        </DefaultContainerCard>
    );
};

export default RumbleMatchCard;
